/**
 * Quantas pessoas cabem numa sala de voz.
 *
 * Um campo e só. Campo vazio quer dizer sala aberta, que é o caso comum; quem
 * quer limitar digita o número.
 *
 * É um campo de texto e não `type="number"` de propósito: o campo numérico do
 * navegador vem com as setinhas de aumentar e diminuir e muda de valor quando
 * a roda do mouse passa por cima, que é um jeito fácil de alterar o limite sem
 * perceber.
 */

import { LIMITS } from '@nexus/shared'
import { Input } from '@/components/ui'

export function ParticipantLimitField({
  valor,
  onChange,
}: {
  /** Zero quer dizer sem limite. */
  valor: number
  onChange: (valor: number) => void
}) {
  return (
    <div className="flex items-center gap-2">
      <Input
        type="text"
        inputMode="numeric"
        value={valor > 0 ? String(valor) : ''}
        placeholder="Sem limite"
        onChange={(evento) => {
          const digitos = evento.target.value.replace(/\D/g, '')
          if (digitos === '') {
            onChange(0)
            return
          }
          onChange(Math.min(Number(digitos), LIMITS.voiceUserLimit.max))
        }}
        className="w-36 tabular-nums"
      />

      {valor > 0 ? (
        <span className="text-[13px] text-content-secondary">
          {valor === 1 ? 'pessoa' : 'pessoas'}
        </span>
      ) : null}
    </div>
  )
}
